import { createSlice } from '@reduxjs/toolkit';
import { UiState } from 'constants/ui';
import { ExtraServiceCheckoutModal } from 'constants/extra-service';
import { stateName } from './constants';
export const initialState = {
  directDonationOrder: {
    fetchUiState: UiState.Idle,
    prepareUiState: UiState.Idle
  },
  directDonationCheckout: {
    activeModal: ExtraServiceCheckoutModal.None
  }
};

const clearCurrentOrder = draft => {
  draft.directDonationOrder = {
    order: undefined,
    prepareUiState: UiState.Idle,
    fetchUiState: UiState.Idle
  };
};

const prepareOrderRequest = draft => {
  draft.directDonationOrder = {
    order: undefined,
    prepareUiState: UiState.Pending,
    fetchUiState: UiState.Idle
  };
};

const prepareOrderFailure = (draft, action) => {
  const {
    message
  } = action.payload;
  draft.directDonationOrder = {
    order: undefined,
    errorMessage: message,
    prepareUiState: UiState.Failure,
    fetchUiState: UiState.Idle
  };
};

const prepareOrderSuccess = (draft, action) => {
  const {
    order
  } = action.payload;
  draft.directDonationOrder = {
    order,
    prepareUiState: UiState.Success,
    fetchUiState: UiState.Idle
  };
};

const setCheckoutModal = (draft, action) => {
  const {
    modal
  } = action.payload;
  draft.directDonationCheckout.activeModal = modal;
};

const getOrderRequest = draft => {
  draft.directDonationOrder = {
    order: undefined,
    fetchUiState: UiState.Pending,
    prepareUiState: UiState.Idle
  };
};

const getOrderFailure = draft => {
  draft.directDonationOrder = {
    order: undefined,
    fetchUiState: UiState.Failure,
    prepareUiState: UiState.Idle
  };
};

const getOrderSuccess = (draft, action) => {
  const {
    order
  } = action.payload;
  draft.directDonationOrder = {
    order,
    fetchUiState: UiState.Success,
    prepareUiState: UiState.Idle
  };
};

const directDonationSlice = createSlice({
  name: stateName,
  initialState,
  reducers: {
    setCheckoutModal,
    getOrderRequest,
    getOrderFailure,
    getOrderSuccess,
    clearCurrentOrder,
    prepareOrderRequest,
    prepareOrderFailure,
    prepareOrderSuccess
  }
});
export const {
  actions
} = directDonationSlice;
export const plug = {
  [stateName]: directDonationSlice.reducer
};
export default directDonationSlice.reducer;